import React, { useState, useRef, useEffect } from "react";

import { addData, getAllData } from "../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import PageHeader from "../../components/PageHeader";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import {
  TableFooter,
  TablePagination,
  Switch,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Paper,
  IconButton,
  TableRow,
  TableHead,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  Box,
} from "@mui/material";

import { endPoints } from "../../constant/Environment";

const ITEM_HEIGHT = 48;

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

const MailInList = () => {
  const [rows, setRows] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    fetchConfiguration();
  }, []);

  const fetchConfiguration = async () => {
    let url = `${endPoints.api.MAIL_IN_LIST}`;
    setIsLoading(true);
    await getAllData(url)
      .then((response) => {
        setIsLoading(false);
        if (response.status === "success") {
          setRows(response.data);
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };
  console.log("rows", rows);
  const rowsToDisplay = rows;

  return (
    <>
      <div className="main">
        <Toaster></Toaster>

        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <PageHeader title="Mail-In List" crumb="Promotions / Mail-In List" />

              <div style={{ marginTop: "10px" }}>
                <div className="row">
                  <div className="col-md-12">
                    <TableContainer component={Paper}>
                      <Table
                        className="c_table"
                        size="small"
                        stickyHeader
                        sx={{ minWidth: 500 }}
                        aria-label="custom pagination table"
                      >
                        <TableHead>
                          <TableRow>
                            {/* <TableCell align="center"> User Id</TableCell> */}
                            <TableCell align="center"> Code</TableCell>
                            <TableCell align="center"> Sender Email</TableCell>
                            <TableCell align="center"> Receiver Email</TableCell>
                            <TableCell align="center"> Use Email</TableCell>
                            {/* <TableCell align="center"> offer Name</TableCell>
                            <TableCell align="center">Gold Coins </TableCell> */}
                            <TableCell align="center">Saga Coins</TableCell>
                            {/* <TableCell align="center">User Image</TableCell> */}
                            <TableCell align="center">Code Used</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rowsToDisplay
                            .slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            .map((row) => (
                              <TableRow
                                key={row.id}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                }}
                              >
                                {/* <TableCell align="center">
                                  {row.id_user}
                                </TableCell> */}
                                <TableCell align="center">{row.code}</TableCell>
                                <TableCell align="center">
                                  {row.refer_email}
                                </TableCell>
                                <TableCell align="center">
                                  {row.email}
                                </TableCell>
                                <TableCell align="center">
                                  {row.use_email}
                                </TableCell>
                                
                                {/* <TableCell align="center">{`${row?.offerName}`}</TableCell>
                                <TableCell align="center">
                                  {row.goldCoin}
                                </TableCell> */}
                                <TableCell align="center">{row.saga}</TableCell>

                                {/* <TableCell align="center">
                                  <img
                                    src={`${endPoints.apiBaseUrl}${row.post_image}`}
                                    style={{ height: "50px" }}
                                  />
                                </TableCell> */}
                                <TableCell align="center">
                                  {row.isUsed ? "Yes" : "No"}
                                </TableCell>
                              </TableRow>
                            ))}

                          {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                              <TableCell colSpan={6} />
                            </TableRow>
                          )}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              rowsPerPageOptions={[
                                5,
                                10,
                                25,
                                { label: "All", value: -1 },
                              ]}
                              colSpan={12}
                              count={rowsToDisplay.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              SelectProps={{
                                inputProps: {
                                  "aria-label": "rows per page",
                                },
                                native: true,
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MailInList;
